document.addEventListener('DOMContentLoaded', function () {
	const slidesContainers = document.querySelectorAll('.regenerativa-slides');

	slidesContainers.forEach((container) => {
		const slidesWrapper = container.querySelector('.slides-container');
		const slides = slidesWrapper
			? slidesWrapper.querySelectorAll('.regenerativa-slide')
			: [];
		const prevBtn = container.querySelector('.slide-nav.prev');
		const nextBtn = container.querySelector('.slide-nav.next');
		const indicatorsContainer = container.querySelector('.slide-indicators');

		if (slides.length <= 1) return;

		let currentSlide = 0;
		let autoPlayTimer = null;
		let manualInteraction = false;

		const autoPlay = container.dataset.autoplay === 'true';
		const delay = parseInt(container.dataset.delay) || 5000;
		const minHeight = container.dataset.minHeight || '100vh';
		const isMobile = window.innerWidth < 768;

		// Setup desktop fade mode
		if (!isMobile) {
			slidesWrapper.style.position = 'relative';
			container.style.setProperty('--slides-min-height', minHeight);
			slidesWrapper.style.height = minHeight;
			slides.forEach((slide, index) => {
				slide.style.position = 'absolute';
				slide.style.top = '0';
				slide.style.left = '0';
				slide.style.width = '100%';
				slide.style.height = '100%';
				slide.style.transition = 'opacity 0.5s ease-in-out';
				slide.style.opacity = index === 0 ? '1' : '0';
				slide.style.pointerEvents = index === 0 ? 'auto' : 'none';
				slide.style.zIndex = index === 0 ? '1' : '0';
			});
		}

		// Setup mobile slide mode
		if (isMobile) {
			slidesWrapper.style.transition = 'transform 0.5s ease-in-out';
		}

		// Create indicators
		if (indicatorsContainer) {
			indicatorsContainer.innerHTML = '';
			slides.forEach((_, index) => {
				const indicator = document.createElement('button');
				indicator.className = `slide-indicator ${
					index === currentSlide ? 'active' : ''
				}`;
				indicator.setAttribute('aria-label', `Go to slide ${index + 1}`);
				indicator.addEventListener('click', () => goToSlide(index));
				indicatorsContainer.appendChild(indicator);
			});
		}

		function updateSlide() {
			if (isMobile) {
				// Mobile: use sliding
				if (slidesWrapper) {
					slidesWrapper.style.transform = `translateX(-${
						currentSlide * 100
					}%)`;
				}
			} else {
				// Desktop: use fade
				slides.forEach((slide, index) => {
					slide.style.opacity = index === currentSlide ? '1' : '0';
					slide.style.pointerEvents =
						index === currentSlide ? 'auto' : 'none';
					slide.style.zIndex = index === currentSlide ? '1' : '0';
				});
			}

			// Update indicators
			if (indicatorsContainer) {
				const indicators =
					indicatorsContainer.querySelectorAll('.slide-indicator');
				indicators.forEach((indicator, index) => {
					indicator.className = `slide-indicator ${
						index === currentSlide ? 'active' : ''
					}`;
				});
			}
		}

		function goToSlide(index) {
			currentSlide = index;
			updateSlide();
			manualInteraction = true;
			resetAutoPlay();
		}

		function nextSlide() {
			currentSlide = (currentSlide + 1) % slides.length;
			updateSlide();
			manualInteraction = true;
			resetAutoPlay();
		}

		function prevSlide() {
			currentSlide = (currentSlide - 1 + slides.length) % slides.length;
			updateSlide();
			manualInteraction = true;
			resetAutoPlay();
		}

		function resetAutoPlay() {
			if (autoPlayTimer) {
				clearInterval(autoPlayTimer);
			}
			if (autoPlay && !manualInteraction) {
				autoPlayTimer = setInterval(nextSlide, delay);
			}
		}

		// Event listeners
		if (prevBtn) {
			prevBtn.addEventListener('click', prevSlide);
		}
		if (nextBtn) {
			nextBtn.addEventListener('click', nextSlide);
		}

		// Touch/swipe support for mobile
		let startX = 0;
		let isDragging = false;

		function handleTouchStart(e) {
			startX = e.touches[0].clientX;
			isDragging = true;
			if (autoPlayTimer) {
				clearInterval(autoPlayTimer);
			}
		}

		function handleTouchMove(e) {
			if (!isDragging) return;
			e.preventDefault();
		}

		function handleTouchEnd(e) {
			if (!isDragging) return;
			isDragging = false;

			const endX = e.changedTouches[0].clientX;
			const diffX = startX - endX;

			if (Math.abs(diffX) > 50) {
				// Minimum swipe distance
				manualInteraction = true;
				if (diffX > 0) {
					nextSlide();
				} else {
					prevSlide();
				}
			} else {
				resetAutoPlay();
			}
		}

		// Add touch event listeners only on mobile
		if (isMobile && slidesWrapper) {
			slidesWrapper.addEventListener('touchstart', handleTouchStart, {
				passive: false,
			});
			slidesWrapper.addEventListener('touchmove', handleTouchMove, {
				passive: false,
			});
			slidesWrapper.addEventListener('touchend', handleTouchEnd);
		}

		// Initialize
		updateSlide();
		resetAutoPlay();
	});
});
